export default __webpack_public_path__ + "static/github-c5f27d4a6c95e952b4c82b3e0574143d.png";